document.addEventListener("click", function (e) {
    const clearAll = e.target.closest("facet-remove a");
    if (clearAll) {
        e.preventDefault();
        window.location.href = clearAll.getAttribute("href");
    }
});
document.addEventListener("DOMContentLoaded", function () {
    initVariantAvailability();
    function initVariantAvailability() {
        const productCards = document.querySelectorAll(".product-card:not([data-variants-initialized])");
        productCards.forEach((card) => {
            const productJsonScript = card.querySelector(".product-json");
            if (!productJsonScript) return;
            try {
                const productData = JSON.parse(productJsonScript.textContent);
                const variants = productData.variants;
                const featuredImage = productData.featured_image;
                const colorSwatches = card.querySelectorAll(".color-swatch");
                const caratDropdown = card.querySelector(".variant-carat .variant-dropdown");
                const qualityDropdown = card.querySelector(".variant-quality .variant-dropdown");
                const productImage = card.querySelector(".product-card__image img");
                const productLink = card.querySelector(".product-card__title a");
                const ImagegproductLink = card.querySelector(".product-card__image ");
                const defaultImageSrc = productImage?.src || "";
                const initialProductUrl = productLink ? productLink.href : "";
                const priceElement = card.querySelector(".product-card__price");
                const addToCartBtn = card.querySelector(".cstm_btn_wrapper a");
                let currentSelections = {
                    color: card.querySelector(".color-swatch.active")?.dataset.optionValue || "",
                    carat: caratDropdown?.value || "",
                    quality: qualityDropdown?.value || "",
                };
                function checkVariantAvailability(color, carat, quality) {
                    return variants.find(
                        (variant) =>
                            variant.option1 === color && variant.option2 === carat && variant.option3 === quality
                    );
                }
                function getCurrentVariant() {
                    return checkVariantAvailability(
                        currentSelections.color,
                        currentSelections.carat,
                        currentSelections.quality
                    );
                }
                function updateProductUrl(variant) {
                    if (!productLink) return;
                    const urlObj = new URL(initialProductUrl, window.location.origin);
                    urlObj.searchParams.delete("variant");
                    if (!variant) {
                        productLink.href = urlObj.toString();
                        if (ImagegproductLink) ImagegproductLink.href = urlObj.toString();
                        return;
                    }
                    urlObj.searchParams.set("variant", variant.id);
                    productLink.href = urlObj.toString();
                    if (ImagegproductLink) ImagegproductLink.href = urlObj.toString();
                }
                function updateProductImage(variant) {
                    if (!productImage) return;
                    let newImageSrc = defaultImageSrc;
                    if (variant && variant.featured_image && variant.featured_image.src) {
                        const variantImageSrc = variant.featured_image.src;
                        newImageSrc = variantImageSrc.replace(/\?(.*)$/, "");
                        if (!newImageSrc.includes("_500x") && !newImageSrc.includes(".webp")) {
                            newImageSrc = newImageSrc.replace(/\.(jpg|jpeg|png|webp)/, "_500x.$1");
                        }
                        if (variantImageSrc.includes(".webp") && !newImageSrc.includes("_500x")) {
                            newImageSrc = newImageSrc.replace(".webp", "_500x.webp");
                        }
                    }
                    if (productImage.src !== newImageSrc) {
                        productImage.src = newImageSrc;
                        if (variant && variant.featured_image && variant.featured_image.alt) {
                            productImage.alt = variant.featured_image.alt;
                        } else if (variant) {
                            productImage.alt = variant.name || productImage.alt;
                        }
                    }
                }
                function updatePrice(variant) {
                    if (!priceElement || !variant) return;
                    const priceInDollars = (variant.price / 100).toFixed(2);
                    priceElement.textContent = `$${priceInDollars}`;
                }
                function addToCart(variant) {
                    if (!variant) {
                        console.error("No variant selected");
                        return;
                    }
                    if (!variant.available) {
                        alert("This variant is out of stock");
                        return;
                    }
                    const formData = new FormData();
                    formData.append("id", variant.id);
                    formData.append("quantity", "1");
                    fetch("/cart/add.js", { method: "POST", body: formData })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log("Added to cart:", data);
                            window.location.href = "/cart";
                        })
                        .catch((error) => {
                            console.error("Error adding to cart:", error);
                            alert("Error adding item to cart. Please try again.");
                        });
                }
                function updateAllOptionAvailability() {
                    const { color, carat, quality } = currentSelections;
                    if (colorSwatches.length > 0) {
                        colorSwatches.forEach((swatch) => {
                            const swatchColor = swatch.dataset.optionValue;
                            const variant = checkVariantAvailability(swatchColor, carat, quality);
                            if (variant && variant.available) {
                                swatch.classList.remove("disabled", "sold-out");
                                swatch.disabled = !1;
                                swatch.title = swatch.dataset.optionValue;
                            } else {
                                swatch.classList.add("disabled", "sold-out");
                                swatch.disabled = !0;
                                swatch.title = "Out of stock";
                            }
                        });
                    }
                    if (caratDropdown) {
                        let hasAvailableCarat = !1;
                        Array.from(caratDropdown.options).forEach((option) => {
                            const optionCarat = option.value;
                            const variant = checkVariantAvailability(color, optionCarat, quality);
                            if (variant && variant.available) {
                                option.disabled = !1;
                                option.classList.remove("sold-out");
                                option.removeAttribute("aria-disabled");
                                hasAvailableCarat = !0;
                            } else {
                                option.disabled = !0;
                                option.classList.add("sold-out");
                                option.setAttribute("aria-disabled", "true");
                            }
                        });
                        const currentCaratOption = caratDropdown.options[caratDropdown.selectedIndex];
                        if (currentCaratOption?.disabled && hasAvailableCarat) {
                            const availableOptions = Array.from(caratDropdown.options).filter((opt) => !opt.disabled);
                            if (availableOptions.length > 0) {
                                caratDropdown.value = availableOptions[0].value;
                                currentSelections.carat = availableOptions[0].value;
                            }
                        }
                    }
                    if (qualityDropdown) {
                        let hasAvailableQuality = !1;
                        Array.from(qualityDropdown.options).forEach((option) => {
                            const optionQuality = option.value;
                            const variant = checkVariantAvailability(color, carat, optionQuality);
                            if (variant && variant.available) {
                                option.disabled = !1;
                                option.classList.remove("sold-out");
                                option.removeAttribute("aria-disabled");
                                hasAvailableQuality = !0;
                            } else {
                                option.disabled = !0;
                                option.classList.add("sold-out");
                                option.setAttribute("aria-disabled", "true");
                            }
                        });
                        const currentQualityOption = qualityDropdown.options[qualityDropdown.selectedIndex];
                        if (currentQualityOption?.disabled && hasAvailableQuality) {
                            const availableOptions = Array.from(qualityDropdown.options).filter((opt) => !opt.disabled);
                            if (availableOptions.length > 0) {
                                qualityDropdown.value = availableOptions[0].value;
                                currentSelections.quality = availableOptions[0].value;
                            }
                        }
                    }
                    const selectedVariant = getCurrentVariant();
                    if (selectedVariant) {
                        updateProductImage(selectedVariant);
                        updatePrice(selectedVariant);
                        updateProductUrl(selectedVariant);
                    } else {
                        updateProductImage(null);
                        updateProductUrl(null);
                        if (priceElement) {
                            priceElement.textContent = "Unavailable";
                        }
                    }
                }
                function forceSelectColor(colorLabel) {
                    const targetSwatch = Array.from(colorSwatches).find(
                        (s) => s.dataset.optionValue.trim().toLowerCase() === colorLabel.trim().toLowerCase()
                    );
                    if (targetSwatch && !targetSwatch.disabled) {
                        colorSwatches.forEach((s) => s.classList.remove("active"));
                        targetSwatch.classList.add("active");
                        currentSelections.color = targetSwatch.dataset.optionValue;
                        updateAllOptionAvailability();
                        console.log(`Filter success: Card ${productData.id} updated to ${colorLabel}`);
                        return !0;
                    }
                    return !1;
                }
                card.variantController = { forceSelectColor: forceSelectColor };
                card.setAttribute("data-variants-initialized", "true");
                colorSwatches.forEach((swatch) => {
                    swatch.addEventListener("click", function () {
                        if (this.disabled) return;
                        colorSwatches.forEach((s) => s.classList.remove("active"));
                        this.classList.add("active");
                        currentSelections.color = this.dataset.optionValue;
                        updateAllOptionAvailability();
                    });
                });
                if (caratDropdown) {
                    caratDropdown.addEventListener("change", function () {
                        currentSelections.carat = this.value;
                        updateAllOptionAvailability();
                    });
                }
                if (qualityDropdown) {
                    qualityDropdown.addEventListener("change", function () {
                        currentSelections.quality = this.value;
                        updateAllOptionAvailability();
                    });
                }
                if (addToCartBtn) {
                    addToCartBtn.addEventListener("click", function (e) {
                        e.preventDefault();
                        const selectedVariant = getCurrentVariant();
                        addToCart(selectedVariant);
                    });
                }
                const initialVariant = variants.find((variant) => variant.available);
                if (initialVariant && !getCurrentVariant()) {
                    currentSelections.color = initialVariant.option1;
                    currentSelections.carat = initialVariant.option2;
                    currentSelections.quality = initialVariant.option3;
                    colorSwatches.forEach((swatch) => {
                        swatch.classList.toggle("active", swatch.dataset.optionValue === currentSelections.color);
                    });
                    if (caratDropdown) caratDropdown.value = currentSelections.carat;
                    if (qualityDropdown) qualityDropdown.value = currentSelections.quality;
                }
                updateAllOptionAvailability();
            } catch (error) {
                console.error("Error parsing product JSON data:", error);
            }
        });
    }
    const productGrid =
        document.querySelector(".product-grid, .grid, .collection-grid, .products-grid") || document.body;
    const observer = new MutationObserver(function (mutations) {
        let shouldReinit = !1;
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                    if (node.classList && node.classList.contains("product-card")) {
                        shouldReinit = !0;
                    } else if (node.querySelector && node.querySelector(".product-card")) {
                        shouldReinit = !0;
                    }
                }
            });
        });
        if (shouldReinit) {
            console.log("New products detected from load more, reinitializing variant availability...");
            setTimeout(() => {
                window.reinitVariantAvailability();
            }, 100);
        }
    });
    observer.observe(productGrid, { childList: !0, subtree: !0 });
    window.reinitVariantAvailability = initVariantAvailability;
});
document.addEventListener("DOMContentLoaded", function () {
    const filterCheckbox = document.getElementById("inStockFilter");
    const products = document.querySelectorAll(".product-card");
    filterCheckbox.addEventListener("change", function () {
        const showInStockOnly = this.checked;
        products.forEach((product) => {
            const available = product.getAttribute("data-available") === "true";
            product.style.display = showInStockOnly && !available ? "none" : "block";
        });
    });
});
(function () {
    function getActiveMetalFromURL() {
        try {
            const params = new URLSearchParams(window.location.search);
            for (const [key, value] of params.entries()) {
                if (key.indexOf("metalcolor") !== -1 || key.indexOf("filter.v.m.custom.metalcolor") !== -1) {
                    return decodeURIComponent(value).replace(/\+/g, " ").trim();
                }
            }
        } catch (e) {}
        return null;
    }
    function getActiveMetalFromDOM() {
        const activePills = document.querySelectorAll(".active-facets__button, .active-facets a");
        for (const pill of activePills) {
            const text = pill.textContent || pill.innerText || "";
            if (text.indexOf(":") !== -1) {
                const parts = text.split(":");
                if (/metal/i.test(parts[0])) {
                    return parts.slice(1).join(":").trim();
                }
            }
            if (/\d+KT/i.test(text)) {
                return text.trim();
            }
        }
        const possibleInputs = document.querySelectorAll(
            'input[type="checkbox"][name*="metalcolor"]:checked, input[type="radio"][name*="metalcolor"]:checked'
        );
        for (const input of possibleInputs) {
            return input.value.trim();
        }
        return null;
    }
    function getActiveMetal() {
        return getActiveMetalFromURL() || getActiveMetalFromDOM();
    }
    const LOADER_ID = "filter-loader-overlay";
    const LOADER_DURATION_MS = 1000;
    function showLoader() {
        const loader = document.getElementById(LOADER_ID);
        if (loader) {
            loader.style.display = "flex";
        }
    }
    function hideLoader() {
        const loader = document.getElementById(LOADER_ID);
        if (loader) {
            loader.style.display = "none";
        }
    }
    window.APPLY_FILTER_FLAG = !1;
    function applyMetalToCards(metalLabel) {
        if (!metalLabel || window.APPLY_FILTER_FLAG) return;
        window.APPLY_FILTER_FLAG = !0;
        showLoader();
        const targetMetal = metalLabel.trim();
        const allCards = document.querySelectorAll(".product-card");
        let uninitializedCount = 0;
        allCards.forEach((card) => {
            if (!card.getAttribute("data-variants-initialized")) uninitializedCount++;
        });
        if (uninitializedCount > 0 && allCards.length > 0) {
            window.APPLY_FILTER_FLAG = !1;
            setTimeout(() => applyMetalToCards(metalLabel), 150);
            return;
        }
        allCards.forEach((card) => {
            if (card.variantController && typeof card.variantController.forceSelectColor === "function") {
                card.variantController.forceSelectColor(targetMetal);
            }
        });
        setTimeout(() => {
            window.APPLY_FILTER_FLAG = !1;
            hideLoader();
        }, LOADER_DURATION_MS);
    }
    function handleFilterChange() {
        const activeMetal = getActiveMetal();
        applyMetalToCards(activeMetal);
    }
    document.addEventListener("DOMContentLoaded", () => {
        setTimeout(handleFilterChange, 500);
    });
    const originalReinit = window.reinitVariantAvailability;
    window.reinitVariantAvailability = function () {
        if (typeof originalReinit === "function") originalReinit();
        setTimeout(handleFilterChange, 300);
    };
    (function () {
        const pushState = history.pushState;
        history.pushState = function () {
            pushState.apply(history, arguments);
            setTimeout(handleFilterChange, 200);
        };
        const replaceState = history.replaceState;
        history.replaceState = function () {
            replaceState.apply(history, arguments);
            setTimeout(handleFilterChange, 200);
        };
    })();
})();
document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname !== "/cart") return;
    setTimeout(function () {
        const variantIdInputs = document.querySelectorAll('input[name="id"][type="hidden"]');
        variantIdInputs.forEach((input) => {
            const variantId = input.value;
            if (!variantId || isNaN(variantId)) return;
            const cartItemContainer =
                input.closest("form") ||
                input.closest('[class*="cart-item"]') ||
                input.closest('[class*="cart-row"]') ||
                input.closest(".cart-line-item");
            if (!cartItemContainer) return;
            const productLink = cartItemContainer.querySelector('a[href*="/products/"]:not([href*="/collections/"])');
            if (!productLink) return;
            const url = new URL(productLink.href, window.location.origin);
            url.searchParams.set("variant", variantId);
            productLink.href = url.toString();
            console.log(`Cart variant URL updated: ${productLink.href}`);
        });
    }, 1000);
});
document.addEventListener("DOMContentLoaded", function () {
    if (!window.location.pathname.includes("/products/")) return;
    setTimeout(function () {
        const urlParams = new URLSearchParams(window.location.search);
        const variantIdFromUrl = urlParams.get("variant");
        if (!variantIdFromUrl) {
            console.log("No variant ID in URL, skipping pre-selection");
            return;
        }
        const productJsonScript = document.querySelector(
            '.product-json, script[type="application/json"][data-product]'
        );
        if (!productJsonScript) {
            console.log("No product JSON found on page");
            return;
        }
        try {
            const productData = JSON.parse(productJsonScript.textContent);
            const variants = productData.variants;
            const targetVariant = variants.find((v) => v.id == variantIdFromUrl);
            if (!targetVariant) {
                console.log("Target variant not found in product data");
                return;
            }
            const colorSwatches = document.querySelectorAll(".color-swatch");
            const caratDropdown = document.querySelector(".variant-carat .variant-dropdown");
            const qualityDropdown = document.querySelector(".variant-quality .variant-dropdown");
            if (colorSwatches.length > 0 && targetVariant.option1) {
                const targetSwatch = Array.from(colorSwatches).find(
                    (s) => s.dataset.optionValue.trim().toLowerCase() === targetVariant.option1.trim().toLowerCase()
                );
                if (targetSwatch) {
                    colorSwatches.forEach((s) => s.classList.remove("active"));
                    targetSwatch.classList.add("active");
                    targetSwatch.click();
                    console.log(`Selected color: ${targetVariant.option1}`);
                }
            }
            if (caratDropdown && targetVariant.option2) {
                caratDropdown.value = targetVariant.option2;
                caratDropdown.dispatchEvent(new Event("change"));
                console.log(`Selected carat: ${targetVariant.option2}`);
            }
            if (qualityDropdown && targetVariant.option3) {
                qualityDropdown.value = targetVariant.option3;
                qualityDropdown.dispatchEvent(new Event("change"));
                console.log(`Selected quality: ${targetVariant.option3}`);
            }
        } catch (error) {
            console.error("Error pre-selecting variant on product page:", error);
        }
    }, 1500);
});
